import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyDZSzXdv7GgqHv16OWUUR1YyG3_9MimvsY',
  authDomain: 'zoilife.firebaseapp.com',
  projectId: 'zoilife',
  storageBucket: 'zoilife.appspot.com',
  messagingSenderId: '612364387063',
  appId: '1:612364387063:web:cd2f90239a987b2e67c9f2',
};

const fire = firebase.initializeApp(config);
export const db = fire.firestore();
export const auth = fire.auth();
export default fire;
